import { Link } from 'react-router-dom';

export function SiteHeader() {
  return (
    <div className="navbar navbar-dark" style={{ backgroundColor: '#8800ff' }}>
      <div className="container d-flex justify-content-between">
        <Link to="/" className="navbar-brand d-flex align-items-center">
          The Stakeholder Takeover Project &nbsp; &nbsp;
          <em style={{ fontSize: '70%' }}>Humanizing corporations through the market power of people</em>
        </Link>
      </div>
    </div>
  );
}
